Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.StageQuality = module.exports.default = {
	BEST: "best",
	HIGH: "high",
	LOW: "low",
	MEDIUM: "medium"
};